import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

// Device-based $2 unlock status. No accounts, no sign-in — the backend checks
// the X-Device-Id header (attached globally in api.js).
const EntitlementContext = createContext(null);

export function EntitlementProvider({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/me/entitlement");
      setUnlocked(!!r.data.unlocked);
    } catch {
      setUnlocked(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <EntitlementContext.Provider value={{ unlocked, loading, refresh }}>
      {children}
    </EntitlementContext.Provider>
  );
}

export const useEntitlement = () => useContext(EntitlementContext);
